import React, { useContext, useEffect } from 'react'
import BoxSlotList from './BoxSlotList/BoxSlotList'
import ErrorPage from '../ErrorPage/ErrorPage'
import PublicContext from '../PublicContext'
import { useSearchParams } from 'react-router-dom'

export default function BoxPage () {
  const { box, setUser, user } = useContext(PublicContext)
  const [searchParams, _] = useSearchParams()

  useEffect(() => {
    const value = searchParams.get('from') || 'web'
    if (user?.from !== value) {
      setUser({ ...user, from: value })
    }
  }, [])

  return (
    <>
      {box && box.active &&
        <BoxSlotList />
      }
      {box && !box?.active &&
        <ErrorPage error="box_inactive" name={`${box.name} - ${box.zip_code}`} />
      }
    </>
  )
}
